import { render } from "./ShareShioriModal.vue?vue&type=template&id=2776e726&scoped=true"
import script from "./ShareShioriModal.vue?vue&type=script&lang=js"
export * from "./ShareShioriModal.vue?vue&type=script&lang=js"

import "./ShareShioriModal.vue?vue&type=style&index=0&id=2776e726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2776e726"]])

export default __exports__